<template>
    <div class="invite-check-overview">
        <b-tabs
            class="group-show-tab apprentice-tab"
            v-model="tabIndex"
            nav-wrapper-class="tab-content-wrapper"
            content-class="group-overview"
            fill>
            <b-tab active>
                <template v-slot:title>
                    {{ $t('group_pair.overview') }}
                </template>

                <design-2021-group-pair-index-overview-component
                    :group-in="groupIn"
                    :coordinator-in="coordinatorIn"></design-2021-group-pair-index-overview-component>
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    {{ $t('group_pair.students_without_request') }}
                </template>

                <design-2021-group-pair-index-students-left-component
                    :has-las="hasLas"
                    :group-id-in="groupIn.id"></design-2021-group-pair-index-students-left-component>
            </b-tab>
            <b-tab v-if="groupIn.group_pair_options.teacher">
                <template v-slot:title>
                    {{ $t('group_pair.teachers') }}
                </template>
                <design-2021-group-pair-index-teacher-component
                    :group-id-in="groupIn.id"
                    :check-option="groupIn.group_pair_options.check_option">
                </design-2021-group-pair-index-teacher-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-group-pair-index-component',
    props: ['hasLas', 'groupIn', 'coordinatorIn'],
    data() {
        return {
            tabIndex: 0,
        };
    },
    mounted() {
        if (localStorage.getItem('tab')) {
            this.tabIndex = 1; // werkt nog niet.
            localStorage.removeItem('tab');
        }
        ords.use('group').add(this.groupIn);
    },
};
</script>

<style scoped>
.tabs >>> .group-overview {
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 0;
}

.group-overview {
    color: #212529;
}

.tabs >>> .nav-link i {
    color: #007bff;
    margin-right: 10px;
}
</style>
